import React, { useEffect, useState } from 'react';
import './WeatherSection.css';

// WMO weather code -> { icon, label (Croatian) }
const WEATHER_CODE_MAP = {
  0:  { icon: '☀️', label: 'Vedro' },
  1:  { icon: '🌤️', label: 'Pretežno vedro' },
  2:  { icon: '⛅', label: 'Djelomično oblačno' },
  3:  { icon: '☁️', label: 'Oblačno' },
  45: { icon: '🌫️', label: 'Magla' },
  48: { icon: '🌫️', label: 'Ledena magla' },
  51: { icon: '🌦️', label: 'Lagana rosulja' },
  53: { icon: '🌦️', label: 'Rosulja' },
  55: { icon: '🌦️', label: 'Jaka rosulja' },
  61: { icon: '🌧️', label: 'Slaba kiša' },
  63: { icon: '🌧️', label: 'Kiša' },
  65: { icon: '🌧️', label: 'Jaka kiša' },
  71: { icon: '🌨️', label: 'Slab snijeg' },
  73: { icon: '🌨️', label: 'Snijeg' },
  75: { icon: '❄️', label: 'Jak snijeg' },
  80: { icon: '🌦️', label: 'Pljuskovi' },
  81: { icon: '🌧️', label: 'Jaki pljuskovi' },
  82: { icon: '⛈️', label: 'Vrlo jaki pljuskovi' },
  95: { icon: '⛈️', label: 'Grmljavinsko nevrijeme' },
  96: { icon: '⛈️', label: 'Grmljavina s tučom' },
  99: { icon: '⛈️', label: 'Jaka grmljavina s tučom' },
};

const describe = (code) =>
  WEATHER_CODE_MAP[code] || { icon: '🌤️', label: 'Promjenjivo' };

const WeatherSection = ({
  date = '2026-06-06',
  latitude = 45.8131,
  longitude = 15.978,
  message = 'Vrijeme će biti predivno, savršeno za uživanje u našem posebnom danu. Jedva čekamo da dođe! 😊',
}) => {
  const [weather, setWeather] = useState(null);
  const [status, setStatus] = useState('loading'); // 'loading' | 'ready' | 'error'

  useEffect(() => {
    const url =
      `https://api.open-meteo.com/v1/forecast` +
      `?latitude=${latitude}` +
      `&longitude=${longitude}` +
      `&daily=temperature_2m_max,temperature_2m_min,weather_code` +
      `&timezone=Europe%2FZagreb` +
      `&start_date=${date}` +
      `&end_date=${date}`;

    let cancelled = false;
    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        if (cancelled) return;
        const d = data?.daily;
        if (d?.temperature_2m_max?.length) {
          setWeather({
            max: Math.round(d.temperature_2m_max[0]),
            min: Math.round(d.temperature_2m_min[0]),
            code: d.weather_code[0],
          });
          setStatus('ready');
        } else {
          setStatus('error');
        }
      })
      .catch(() => {
        if (!cancelled) setStatus('error');
      });

    return () => {
      cancelled = true;
    };
  }, [date, latitude, longitude]);

  const formattedDate = new Date(date).toLocaleDateString('hr-HR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  const desc = weather ? describe(weather.code) : null;

  return (
    <section className="weather-section" aria-labelledby="weather-title">
      <div className="section-container weather-section__content">
        <h2 id="weather-title" className="weather-section__title">
          Vremenska prognoza
        </h2>

        <div className="weather-section__divider" aria-hidden="true" />

        <div className="weather-section__body">
          <div className="weather-section__card" aria-live="polite">
            {status === 'loading' && (
              <p className="weather-section__placeholder">Učitavam prognozu…</p>
            )}

            {status === 'error' && (
              <p className="weather-section__placeholder">
                Prognoza trenutno nije dostupna.
              </p>
            )}

            {status === 'ready' && weather && (
              <>
                <div className="weather-section__icon" aria-hidden="true">
                  {desc.icon}
                </div>
                <div className="weather-section__temps">
                  <span className="weather-section__temp-max">{weather.max}°</span>
                  <span className="weather-section__temp-min">/ {weather.min}°</span>
                </div>
                <p className="weather-section__condition">{desc.label}</p>
                <p className="weather-section__location">
                  Zagreb · {formattedDate}
                </p>
              </>
            )}
          </div>

          <p className="weather-section__message">{message}</p>
        </div>
      </div>
    </section>
  );
};

export default WeatherSection;
